export default __webpack_public_path__ + "static/media/download_black_icon.41940c8d.svg";